

import { notasApi } from "../../apis";
import { useNotasStore } from "../../stores/ui/notas.store";
import Swal from "sweetalert2";




// export const gastoXID = async(id) => {
//     try {
//         const { data } = await gastosApi.get(`/gasto/${id}`);
//         return data.data;
//     } catch (error) {
//         const errores = error.response.data['msg'] || error.response.data.errors[0]['msg'];
//         Swal.fire('Error', errores, 'error');
//         return false;
//     }
// }




export const listadoTodasNotas = async({ page=0, termino }) => {
    try {
        const params = new URLSearchParams();
        params.append('page',  page.toString());
        params.append('termino',  termino);
        const { data } = await notasApi.get('/todos', { params });
        useNotasStore.setState({ totalNotas : data.total });
        return data.data;
    } catch (error) {
        const errores = error.response.data['msg'] || error.response.data.errors[0]['msg'];
        Swal.fire('Error', errores, 'error');
        return false;
    }
}



export const aprobarNotaIngreso = async(body) => {
    try {
        const { data } = await notasApi.post('/aprobar', body);
        Swal.fire('Exitoso', data.msg, 'success');
        return true;
    } catch (error) {
        const errores = error.response.data['msg'] || error.response.data.errors[0]['msg'];
        Swal.fire('Error', errores, 'error');
        return false;
    }
}

